// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'
import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'

import Table from '@mui/material/Table'
import TableRow from '@mui/material/TableRow'
import TableBody from '@mui/material/TableBody'
import TableCell, { TableCellBaseProps } from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'

import {
    Divider,
    IconButton,
    Tooltip,
    Fab,
    Typography,
    Card,
    CircularProgress,
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import CardStats from '../../../components/card/CardStats';
import { useToast } from '../../../components/ToastProvider';
import MsiDatagridAutoPlain from '../../../components/custom/MsiDatagridAutoPlain'
import TablePR from '../../../components/purchasing/TablePR'

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    // ** State
    const [listArray, setListArray] = useState<any[]>([])
    const [listSetting, setListSetting] = useState<any[]>([])

    const [openDialog, setOpenDialog] = useState<boolean>(false)

    const [minFashion, setMinFashion] = useState<string>('0')
    const [minSprei, setMinSprei] = useState<string>('0')
    const [minPolosan, setMinPolosan] = useState<string>('0')


    useEffect(() => {
        getData()
        getHeader()
    }, [])

    const navigate = useNavigate();

    const getData = () => {
        // showToast("Loading...", "loading");
        // let url = ''
        // if (mode == '1') {
        //     url = apiUrl.apiUrl + '/purchasing/pr/dashboard/semua-pr'
        // } else if (mode == '2') {
        //     url = apiUrl.apiUrl + '/purchasing/pr/dashboard/pr-belum-aktif'
        // } else {

        //     url = apiUrl.apiUrl + '/purchasing/pr/dashboard/progress-pembelian'
        // }

        // axios
        //     .get(url, {
        //         params: {
        //             awal: tglAwal,
        //             akhir: tglAkhir
        //         },
        //         headers: { Authorization: `Bearer ${token}` }
        //     })
        //     .then(response => {
        //         if (response.data.success) {
        //             const data = response.data.data
        //             setListData(data)
        //             hideToast();
        //         } else {
        //             showToast(response.data.message, "success");
        //         }
        //     })
    }

    const getHeader = () => {

    }

    const targetComponent = [
        {
            key: 'min_fashion',
            renderCell: ({ row }: any) => (
                <div onClick={() => handleClickDialog(row)} style={{ cursor: 'pointer' }}>
                    <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                        {row.min_fashion?.toLocaleString('id-ID', { maximumFractionDigits: 2 })}
                    </Typography>
                </div>
            )
        },
        {
            key: 'min_sprei',
            renderCell: ({ row }: any) => (
                <div onClick={() => handleClickDialog(row)} style={{ cursor: 'pointer' }}>
                    <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                        {row.min_sprei?.toLocaleString('id-ID', { maximumFractionDigits: 2 })}
                    </Typography>
                </div>
            )
        },
        {
            key: 'min_polosan',
            renderCell: ({ row }: any) => (
                <div onClick={() => handleClickDialog(row)} style={{ cursor: 'pointer' }}>
                    <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                        {row.min_polosan?.toLocaleString('id-ID', { maximumFractionDigits: 2 })}
                    </Typography>
                </div>
            )
        }
    ]

    const handleClickDialog = (params: any) => {
        setMinFashion(params.min_fashion)
        setMinPolosan(params.min_polosan)
        setMinSprei(params.min_sprei)
        if (user.sysrole_id == 65 || user.sysrole_id == 1) {
            setOpenDialog(true)
        }
    }
    const handleCloseDialog = () => {
        setOpenDialog(false)
    }

    const setDetailArray = (data: any, index: any) => {
        const rows = [...listArray]
        rows[index].load = 1
        rows[index].detail = data
        setListArray(rows)
    }

    const refreshData = (index: any) => {
        const rows = [...listArray]
        const item = rows[index].keterangan_pembelian
        rows[index].open = 1
        rows[index].load = 0
        setListArray(rows)
        // getDetail(item, index)
    }

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='PR BAHAN BAKU' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Typography variant='h6' textAlign={'center'}>
                            Setting Min. Stock
                        </Typography>
                        <MsiDatagridAutoPlain array={listSetting} />
                    </CardContent>
                </div>
            </Grid>
            {listArray.map((item, index) => {
                return (
                    <Grid item xs={12} key={index}>
                        <Card
                            variant='outlined'
                            sx={{
                                borderColor: '#212121'
                            }}
                        >
                            <Box sx={{ padding: 1, backgroundColor: 'primary.main', mb: 5 }}>
                                <Typography variant='h6' sx={{ textAlign: 'center', color: 'white' }}>
                                    {item.keterangan_pembelian}
                                </Typography>
                            </Box>
                            {item.load == 0 ? (
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', margin: 10 }}>
                                    <CircularProgress disableShrink sx={{ height: '100%' }} />
                                </Grid>
                            ) : (
                                <TablePR
                                    array={item.detail}
                                    title={item.keterangan_pembelian}
                                    stock={item.min_kebutuhan}
                                    metode={item.metode}
                                    indexArr={index}
                                    refresh={() => refreshData(index)}
                                />
                            )}
                        </Card>
                    </Grid>
                )
            })}
        </Grid>
    )
}